export default __webpack_public_path__ + "static/media/Reports.8882c712.svg";